import type { ValidityStatus } from "pages/common/types/valid";
import theme from "style/theme";

/**
 * @summary Takes a single argument and returns the corresponding rem value
 *
 * @external "style/theme"
 *
 * @param targetSize Target value to be transformed
 *
 * @returns Returns corresponding rem unit or false if not a number
 *
 * @example remCalculator(theme.fontSizeBase)
 * returns: '1rem'
 */

export const remCalculator = (targetSize?: any): string => {
    return `${targetSize / theme.fontSizeBase}rem`;
};

/**
 *
 * @function
 * @summary - This helper sets style attributes on styled components. In some cases where frequent updates are made to a style, we want to set these to be defined on the style attribute rather than by the generated class as frequent updates to the class name are imperformant and cause styled components to throw a warning.
 * @param {ThemedStyledFunction} el The styled component element to which the inline styles will be applied to
 * @param {Function<Object>} styles The method that will return the styles attribute
 *
 * @returns {ThemedStyledFunction}
 */
export const setInlineStyles = (el, styles = (_props: any) => ({})) => {
    //@ts-ignore: this is complicated to fix
    return el.attrs((props) => ({ style: styles(props) }));
};

/**
 *
 * @function
 * @summary - This function returns a color based on the validity status
 * @param status The props contain both the status to determine the color and the theme which contains the color constants
 *
 * @returns
 */
export const generateColorFromStatus = (status: ValidityStatus): string => {
    switch (status) {
        case `valid`:
            return theme.colors.valid;
        case `incomplete`:
            return theme.colors.waiting;
    }
};
